module.exports = __webpack_public_path__ + "assets/media/s22.e5c8e502.mp3";